import React, { FC } from 'react';
import './Result.scss';
import './ErrorMsgModal.scss';
import { IResultProps } from './IResultProps';
import EksamensResultCard from '../../../SharedComponents/ResultCard/EksamensResultCard';

const Result: FC<IResultProps> = (props) => {
    return (
        <EksamensResultCard
            result={props.result}
            idx={props.idx}
            otherIsDownloading={props.otherIsDownloading}
            setDownloading={props.setDownloading}
        />
    );
}

export default Result;
